/*eslint-disable*/
import { VStack, Heading, Button, Box,  Tag, Flex, Spacer, Text, Alert, Table, Thead, Tbody, Tr, Th, Td, Collapse, Modal, ModalBody, ModalCloseButton, ModalContent, ModalHeader, ModalOverlay, TagLabel, Avatar, Container  } from '@chakra-ui/react';
import { MouseEventHandler, ReactNode, useEffect} from 'react';
import { Link } from 'react-router-dom';
import { useMoralis, useMoralisQuery, useNewMoralisObject } from 'react-moralis';
import { HStack} from '@chakra-ui/react';
import player from "./player.jpg";
import enemy from "./beast.jpg";
import React, { useState, useRef } from "react";
import "./Game.css";
import NftGridG  from  '../../components/NFTGridG';
import Swords from './Swords.jpg';
import miniguns from './Miniguns.jpg';
import missiles from './Missilesystem.jpg';
import Star from './StarGlow.jpg';
import Melee from './Melee.jpg';
import chooseLegend from './chooseLegend.jpg';
import Moralis from 'moralis-v1';
import RampageInfo from './RampageInfo';
import GAMEOVER from './GAMEOVER.gif';
import Audio from './GameAudio';
import GunsSound from './Guns.wav';
import MissileSound from './Missile2.wav';
import LaserSound from './Lasers.wav';
import HealthSound from './HealthAdd.wav';
import MeleeSound from './melee1.wav';
import MissilesExp from './MissilesExp.mp4';
import HealthExp from './HealthExp.mp4';
import GunsExp from './GunsExp2.mp4';
import MeleeExp from './MeleeExp.mp4';
import WinnerExp from './WinnerExp.mp4';
import SkillPic from './Skill.jpg';
import HealthPic from './health.jpg';
import ExpPic from './exp.png';
import TokensPic from './tokens.jpg'
import LaserExp2 from './LaserExp2.mp4';
import RR from './RR.jpg';
import NFTGridEB from '../../components/NFTGridEB';
import TopHighScores from './PlayerScores';
import Hearts from './hearts';
import Meltdowns from './meltdowns'
import Timer from '../tournamentTimer';
import Frame from './frame.png' 
import Healthbar from './frame1.png' 
import Stun from './stun.png'
import Criticalhit from './Critical.jpg'

import forest from './forest1.jpg'
import coast from './coast.jpg'
import greencoast from './greencoast.jpg'
import cave from './cave.jpg'
import icepalace from './cave2.jpg'
import redforest from './redforest.jpg'
import refinery from './refinery4.jpg'
import path from './path.jpg'
import barrencoast from './barrencoast.jpg'
import tower from './tower.jpg'
import temple from './temple1.jpg'
import portal from './portal.jpg'
import circuit from './circuit.jpg'
import circuitred from './circuitred.jpg'
import MapModal from './Map';
import caw from './caw.gif.mp4'




interface DemoGamesAttributes {
  className: 'Game';
  player: String;
  score: number;
  exp: number;
}


  

  

interface RampageLegacy_R3 extends Moralis.Object<DemoGamesAttributes> {
 
}

interface DemoOMA_attributes {
  className: 'DemoRampage_1MA_Teams',
  address: {
    teams: [
      { Team: { score: Number } },
   
    
    ],
  },}
interface Rampage_1MATeams extends Moralis.Object<DemoOMA_attributes> {
}
const DemoRampage_1MATeams = Moralis.Object.extend({
  className: 'DemoRampages_1MA_Teams_R3',

});



const DemoRampageOneManArmy_R3 = Moralis.Object.extend({
  className: 'DemoRampageOneManArmy_R3'
});


const DemoRampageClicker = Moralis.Object.extend({
  className: 'DemoRampageClickerGames'

});

interface NftProps {
  name: string;
  metadata: {
    image?: string;
    attributes: { trait_type: string; value: string | number }[];
  };
  address: string;
  id: string;
  type: string;
}



enum AttackType {
  Melee="Melee",
  RayOfDeath = "Ray Of Death",
  Missiles = "Missiles",
  Miniguns = "Miniguns",
  repairModule= "Repair Module",
  Reloading = "Reloading"
}


const AppGCrofam = () => 

 {
  const [TokenData, setTokenData]=useState(5);
  const [Tokens, setTokens]=useState(0);
  const account=localStorage.getItem('player_name');
const address='0x000000000000000000000000000000000000dead'
const account_name=account
console.log(account);
 

  useEffect(() => {
    setTokens(TokenData);
    const account_name=localStorage.getItem('player_name');
     console.log(account_name);
  }, [])
  
  
  const EnemyTeam = localStorage.getItem('enemyTeam');
  
  const StoredEnemyTeamsData = localStorage.getItem('enemyTeams');
  
  const ParsedEnemyData = StoredEnemyTeamsData ? JSON.parse(StoredEnemyTeamsData) : null;
 // console.log(ParsedEnemyData);
  
  const enemyTeamFind = ParsedEnemyData ? ParsedEnemyData.find((team: any) => team.name === EnemyTeam) : null;
 // console.log(enemyTeamFind);

  const enemyIpfs = enemyTeamFind.ipfs;
 //console.log(enemyIpfs);
 const enemyContract=enemyTeamFind.contract;
//console.log(enemyContract);
const RTVIPdata1 = localStorage.getItem('ebvips');
let RTVIPdata: string[] = []; // Specify the type as an array of strings

if (RTVIPdata1) {
  try {
    RTVIPdata = JSON.parse(RTVIPdata1);
   // console.log(RTVIPdata);
  } catch (error) {
    console.error('Error parsing data from localStorage:', error);
  }
} else {
 // console.log('No data found in localStorage.');
}

const Team = localStorage.getItem('playerTeam');

const StoredPlayerTeamsData = localStorage.getItem('playerTeams');

const ParsedPlayerData = StoredPlayerTeamsData ? JSON.parse(StoredPlayerTeamsData) : null;


const playerTeamFind = ParsedPlayerData?.find((team: any) => team.name === Team);


const playerIpfs = playerTeamFind?.ipfs; 

const playerJsonIpfs =playerTeamFind?.json;
const PlayerTeamIcon=playerTeamFind?.icon;

  useEffect(() => {
    const gameDiv = document.getElementById('stage');
    if (gameDiv) {
      gameDiv.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }, );
  
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpen2, setIsModalOpen2] = useState(false);
  const [exp1, setExp1] = useState(0);
  const [TeamScore, setTeamScore] = useState(Number);

  const [Score, setScore] = useState<number>(1);
 
  const [LegendFromStorage, setLegendFromStorage] = useState('');
  const paddedLegendFromStorage = LegendFromStorage?.toString().padStart(4, '0');
  const [battleOutcome, setBattleOutcome] = useState<React.ReactNode>(null);
 const [selectedEnemy, setSelectedEnemy] = useState<string>('');



  if (LegendFromStorage !== '' && Team === "Legends") {
  fetch(playerJsonIpfs+LegendFromStorage+'.json')
  .then(response => response.json())
  .then(TokenData => {
    localStorage.setItem('TokenData', JSON.stringify(TokenData));
  })
  .catch(error => console.error(error));
 // const TokenData:any = localStorage.getItem('TokenData');
  //const ParsedTokenData=JSON.parse(TokenData);
 
}

 

 useEffect(() => {
  
  const GettingData = async () => {
    if (address){
      const NFTimage = localStorage?.getItem('NFTimage');
      const SelectedTeam = String(NFTimage)===''||String(NFTimage)===null ? chooseLegend : NFTimage;
       /* Team === 'Legends'
          ? paddedLegendFromStorage !== null
            ? (paddedLegendFromStorage === '0000' || LegendFromStorage === '')
              ? chooseLegend
              : playerIpfs + paddedLegendFromStorage + '.png'.replace('ipfs://', 'https://recklessrobots.mypinata.cloud/ipfs/')
            : ''
          : (Team === "CorgiClub" || Team === 'SpaceCRXillions'|| Team === 'MOA' ) && NFTimage !== null
          ? NFTimage
          : LegendFromStorage !== null
          ? (LegendFromStorage === '0000' || LegendFromStorage === '')
            ? chooseLegend
            : playerIpfs + LegendFromStorage + '.png'.replace('ipfs://', 'https://recklessrobots.mypinata.cloud/ipfs/')
          : ''
      );
*/
    // Query the previous score of the user
    const query = new Moralis.Query(DemoRampageOneManArmy_R3);
     await query.equalTo('player', account_name);
    
    try {
      const previousScoreObject = await query.first();
      
      if (previousScoreObject) {
        // Compare the new score with the previous score
        const previousScore = previousScoreObject.get('score');
        if (SelectedTeam){
          previousScoreObject.set('team', SelectedTeam)}
        localStorage.setItem('previousScore', previousScore);
        if (previousScore>0)
        setScore(previousScore);
        else {
          setScore(1);
        }
         
        
      } else {/*
        // Save the score if it's the first score for the user
        const newScoreObject = new RampageOneManArmy_R3();
        newScoreObject.set('player', address);
        newScoreObject.set('score', Score);
        await newScoreObject.save();
        setScore(Score+1-1);*/
      }
    } catch (error) {
      console.error('Error querying or saving score:', error);
    }
  
 
  
   }else 
   return 
     <Alert>Sign in and reload</Alert>}
   GettingData();
 
 }, [account_name, LegendFromStorage])
 
 

//console.log(TeamScore);
useEffect(() => {
    const SettingTeamScore = async () => {
      // Query the previous score of the team
      const query = await new Moralis.Query(DemoRampage_1MATeams);
      await query.equalTo('TeamScores', 'Round 2');
  
      try {
        const previousTeamObject = await query.first();

        if (!previousTeamObject) {
          // Save the exp if it's the first exp for the user
          const newTeamObject = new DemoRampage_1MATeams();
          newTeamObject.set('TeamScores', 'Round 2');
          newTeamObject.set(String(Team), 0);
          
        newTeamObject.set('Player', {
          [String(account_name)]:{ [String(Team)]: { Score: TeamScore }}
         });
          await newTeamObject.save();
          //console.log('new score object created');
        }

        if (previousTeamObject) {
          // Compare the new exp with the previous exp
          const previousTeamScore = await previousTeamObject.get(String(Team));
  
          if (TeamScore === 0) {
            if (previousTeamScore !== undefined) {
              setTeamScore(previousTeamScore);}}
  
          
              if (TeamScore) {
       
                if (previousTeamScore === undefined || TeamScore > previousTeamScore) {
                    // Save the new score if it's higher or if previousExp is undefined
        
      
                    // Save the new score if it's higher or if previousExp is undefined
                    const currentData = previousTeamObject.get('Player') || {}; // Retrieve the current data or an empty object
                    currentData[String(account_name)] = currentData[String(account_name)] || {}; // Create an object for the address if it doesn't exist
                    
                    // Increment the Score for a specific address and team
                    currentData[String(account_name)][String(Team)] = {
                      Score: (currentData[String(account_name)][String(Team)]?.Score || 0) + 1,
                    };
                    
                    previousTeamObject.set('Player', currentData);
                    previousTeamObject.set(String(Team), TeamScore);
                  /*
                    previousTeamObject.set('Player', {
                     [String(address)]:{ [String(Team)]: { Score: TeamScore }}
                    });*/
    
                    await previousTeamObject.save();
                   // console.log('previous saved');
                  }
                   
               
            else {
              setTeamScore(previousTeamScore);

            }
          }


        } 
      } catch (error) {
        console.error('Error querying or saving team score:', error);
      }
    };
  
    SettingTeamScore();
   
  }, [Team, TeamScore]);
  
  
  //console.log(TeamScore);

useEffect(() => {
  const SettingExp = async () => {
    // Query the previous score of the user
    const query = await new Moralis.Query(DemoRampageOneManArmy_R3);
    await query.equalTo('player', account_name);

    try {
      const previousExpObject = await query.first();

      if (previousExpObject) {
        // Compare the new exp with the previous exp
        const previousExp = await previousExpObject.get('exp');

        if (exp1 === 0) {
          if (previousExp !== undefined) {
            setExp1(previousExp);}}

        if (exp1 > 0) {
          if (previousExp === undefined || exp1 > previousExp) {
            // Save the new score if it's higher or if previousExp is undefined
            previousExpObject.set('exp', exp1);
            //console.log(exp1);
            await previousExpObject.save();
            setExp1(exp1);
          } else {
            setExp1(previousExp);
          }
        }
      } else {/*
        // Save the exp if it's the first exp for the user
        const newExpObject = new RampageOneManArmy_R3();
        newExpObject.set('player', address);
        newExpObject.set('exp', 0);
        setExp1(0);
        await newExpObject.save();*/
      }
    } catch (error) {
      console.error('Error querying or saving exp:', error);
    }
  };

  SettingExp();
}, [Score, exp1, account_name]);



useEffect(() => {

  const SettingData = async () => {
  
   
  // Query the previous score of the user
 
  const query = await new Moralis.Query(DemoRampageOneManArmy_R3);
  await query.equalTo('player', account_name);
  
  try {
    const previousScoreObject = await query.first();
  
    if (previousScoreObject) {
      // Compare the new score with the previous score
      const previousScore = await previousScoreObject.get('score');
     
    
      if (Score>1){
      if (Score > previousScore) {
        // Save the new score if it's higher
        previousScoreObject.set('score', Score);
        await previousScoreObject.save();
        setScore(Score);
      } else  {
        await previousScoreObject.set('score', Score);
        await previousScoreObject.save();
       // console.log('Stage:', Score);
      }
       
       
      }
    } else {/*
      // Save the score if it's the first score for the user
      const newScoreObject = new RampageOneManArmy_R3();
      newScoreObject.set('player', address);
      newScoreObject.set('score', Score);
      await newScoreObject.save();
     // console.log('First score saved:', Score);*/
    }

  } catch (error) {
    console.error('Error querying or saving score:', error);
  };}
  
SettingData();

}, [Score || account_name ])







    
  const [armour, setArmour] = useState('');
  const [headGear, setHeadGear] = useState(''); 
  const [backGear, setBackGear] = useState(''); 
  const [frontGear, setFrontGear] = useState(''); 
  const [glow, setGlow] = useState(''); 
  const [battleFlag, setBattleFlag] = useState(''); 
  const [classType, setClassType] = useState(''); 
  const [background, setBackground] = useState(''); 




const Character = (props: { name: string; image: string; attack: AttackType; PlayerisAttacking: boolean; healthLost: number, EnemyAttackType: AttackType, MeltdownsStorage: number, Tokens:number, playerHealth:number; isPlayerCriticalhit:boolean }) => {
 
 



  const { account } = useMoralis();
  const [address, setAddress] = useState<string>(account || '');
  const [chain] = useState<string>('0x19');
  const [searchChain, setSearchChain] = useState<string>('0x19');
  const [searchAddress, setSearchAddress] = useState<string>(account || '');
  const tokenaddresses=['0xf96ec7C11D311920833753FAB9b174B6FD53517E'];
  useEffect(() => {
 
  const LegendFromStorage1 = localStorage.getItem('StoredLegend') || '';
  setLegendFromStorage(LegendFromStorage1);
  const paddedLegendFromStorage = LegendFromStorage1?.toString().padStart(4, '0');
    const TokenData1:any = localStorage.getItem('TokenData');
    const ParsedTokenData=JSON.parse(TokenData1);
    

  let classType:string, background:string, battleFlag:string, armour:string, headGear:string, backGear:string, glow:string, frontGear:string;
if (ParsedTokenData) {
for (let attribute of ParsedTokenData.attributes) {
  switch(attribute.trait_type) {
    case 'Class':
      setClassType(attribute.value);
      break;
    case 'Background':
      setBackground(attribute.value);
      break;
    case 'BattleFlag':
      setBattleFlag(attribute.value);
      break;
    case 'Armour':
      setArmour(attribute.value);
      break;
    case 'HeadGear':
      setHeadGear(attribute.value);
      break;
      case 'BackGear':
      setBackGear(attribute.value);
      break;
      case 'Glow':
        setGlow(attribute.value);
        break;
        case 'FrontGear':
          setFrontGear(attribute.value);
          break;
    default:
     setBattleFlag('None');
      setArmour('None');
      setHeadGear('None');
      setBackGear('None');
      setGlow('None');
      setFrontGear('None');

      break;
  }
}}
},[] );


 







const videoRef = useRef<HTMLVideoElement | null>(null);
const [videoEnded, setVideoEnded] = useState(false);
const videoElement = videoRef.current;






useEffect(() => {

    
  if (videoElement) {
    // console.log('this is running');
     // Pause and reset the video
    // videoElement.pause(); FIX THIS IF MOBILE ERRORS OCCURE
     //videoElement.currentTime = 0;
 
     // Conditionally set the video source based on props.attackType
     /*
     if (props.EnemyAttackType === 'Missiles') {
       videoElement.src = MissilesExp;} 

   if (props.EnemyAttackType === AttackType.RayOfDeath) {
     videoElement.src = LaserExp2;}
     
     if (props.EnemyAttackType === 'Miniguns') {
       videoElement.src = GunsExp;}

   if (props.EnemyAttackType === 'Melee') {
   videoElement.src = MeleeExp; }
   
   if (props.EnemyAttackType === AttackType.repairModule) {
     videoElement.src = HealthExp; }
  else {
       // Default source if none of the conditions match
       if (props.EnemyAttackType === 'Missiles') {
         videoElement.src = MissilesExp;} 
 
     if (props.EnemyAttackType === AttackType.RayOfDeath) {
       videoElement.src = LaserExp2;}
       
       if (props.EnemyAttackType === 'Miniguns') {
         videoElement.src = GunsExp;}
 
     if (props.EnemyAttackType === 'Melee') {
     videoElement.src = MeleeExp;
   

   
   
   }

  
     
     if (props.attack === AttackType.repairModule) {
       videoElement.src = HealthExp; }
      
     }
   */ 
  //REMOVE DISREGARD IF PROBLEMS
     // Start playing the video
    
   
       const playPromise = videoElement.play();
     
     playPromise.catch((error) => {
       console.error("Video play error:", error);
     
     });
  

     // Set up a timeout to unmute the video after a delay (e.g., 100ms)
     const unmuteTimeout = setTimeout(() => {
       videoElement.muted = false;
       videoElement.volume = 0.5;
     }, 100);
 
     
     return () => {
       // Clean up video playback and the timeout when the component is unmounted
       videoElement.pause();
       videoElement.currentTime = 0;
       clearTimeout(unmuteTimeout);
     };
   }

 },);

 const handleVideoEnded = () => {

  setVideoEnded(true);
   
   // Set the videoEnded state to true when the video ends
  // console.log('video ended running');
 };

 const handleVideoStart = () => {
  
   setTimeout(() => {

     if (videoRef.current) {
     videoRef.current.muted = false;
     videoRef.current.volume = 0.5;
   }}, 100);};


   const health1=props.playerHealth;
    
  const getHealthColor = (health:any) => {
    if (health > 75) return 'green !important';
    if (health > 50) return 'yellow !important';
    if (health > 25) return 'orange !important';
    return 'red !important';
  };

const NFTimage1=localStorage.getItem('NFTimage');
const NFTimage=NFTimage1?.replace('ipfs://', 'https://ipfs.io/ipfs/') ?NFTimage1?.replace('ipfs://', 'https://ipfs.io/ipfs/') :chooseLegend;
//console.log('NFTimage:',NFTimage);
//console.log(String(NFTimage!).replace('ipfs://', 'https://ipfs.io/ipfs/'));

//Team!=='MOA'? localStorage?.getItem('NFTimage'): localStorage.getItem('NFTimage')!==null ? localStorage.getItem('NFTimage')!.replace('https://bhfiles.mypinata.cloud/ipfs/','https://ipfs.io/ipfs/'):(localStorage.getItem('NFTimage')) ;
//console.log(LegendFromStorage);
return (
  <VStack>
  <div style={{ width: '100%' }} className={`character ${props.PlayerisAttacking ? 'attacking' : ''}`}>
    <h3>{Team}</h3>
    <div style={{ position: 'relative' }}>
    <Box  boxShadow={ `0px 0px 5px 3px ${getHealthColor(props.playerHealth)}`} overflow={'visible'}  position="absolute"  left={'1'} bottom='1' width="10vmin" height="10vmin" borderRadius="full" bgImage={`url(${Healthbar})`} backgroundSize="cover">
  <Text 
  fontFamily={'DSEG7'} 
  fontSize="1vw" 
  color={getHealthColor(props.playerHealth)} 
  textShadow={`5px 5px 5px ${getHealthColor(props.playerHealth)}`}
  position="absolute" 
  top="50%" 
  left="50%" 
  transform="translate(-50%, -50%)"
>
  {props.playerHealth.toFixed(0)}
</Text>
</Box>

<Box height={'fit-content'}>
      
        


  

 

      <img
      style={{ display:'inline-block', overflow:'hidden' }}
       className={props.healthLost > 0 ? 'health-lost' : props.MeltdownsStorage>4 ? 'fire' :''}
       width={Team==='D.G.P. Unlimited' ? "69%" :"100%"}
       height={Team==='D.G.P. Unlimited' ? "69%" :"auto"}
       
        src={ String(NFTimage)===''||String(NFTimage)===null ? chooseLegend : NFTimage}
         /* Team === 'Legends'
          ? paddedLegendFromStorage !== null && paddedLegendFromStorage !== '' && paddedLegendFromStorage !== '0000'
            ? playerIpfs + paddedLegendFromStorage + '.png'.replace('ipfs://', 'https://recklessrobots.mypinata.cloud/ipfs/')
            : chooseLegend
          : 
            (Team === "CorgiClub" || Team === 'SpaceCRXillions' || Team === 'MOA') &&
           NFTimage !== null
          ? NFTimage
          : LegendFromStorage !== null && LegendFromStorage !== ''
          ? playerIpfs + LegendFromStorage + '.png'.replace('ipfs://', 'https://recklessrobots.mypinata.cloud/ipfs/')
          : chooseLegend

        }*/
      /></Box>
         <Box fontSize={'1vw'} style={{
    opacity: 0.5, // Adjust the opacity value
    filter: 'brightness(2)',   position: 'absolute',
           top: 0,
           left: 0,}}>
      <Meltdowns tokens={props.MeltdownsStorage}/>
      </Box>
       {props.healthLost > 0 && (
   
      <div id='healthtext' className="BlastNumbers animate">
        <p className="BlastNumbers animate">
          -{props.healthLost.toFixed(0)}
        </p>
      </div>
   

        )}

        
{props.isPlayerCriticalhit && (
          <Box className='criticalhit'  overflow={'visible'}  position="absolute"  left={'5vw'} bottom={'5vh'} width="20vmin" height="20vmin" borderRadius="full" bgImage={`url(${Criticalhit})`} backgroundSize="cover">
   <div id='healthtext'  className="BlastNumbers animate">
             <p  className="BlastNumbers animate" >
               -{props.healthLost.toFixed(0)}
             </p></div>
</Box>

)}

         {props.healthLost === 0 && props.EnemyAttackType !== 'Reloading' && (
   <div className="BlastNumbers animate">
   <p
     id='healthtext'
  
  
   
   >
     MISS
   </p>
 </div>
)
}



           {props.healthLost > 0 && props.EnemyAttackType === "Missiles"  &&  (
           <video autoPlay playsInline  muted   ref={videoRef} src={MissilesExp}  style={{
    opacity: 0.35, // Adjust the opacity value
    filter: 'brightness(2)',   position: 'absolute',
           top: 0,
           left: 0,
           width:'fit-content',
           height:"auto",
           pointerEvents: 'none', // Ensure the GIF doesn't interfere with interactions
         // Specify the animation name and duration
          }}   onPlay={handleVideoStart} onEnded={handleVideoEnded}  />
          )}

{props.healthLost > 0 && props.EnemyAttackType === "Miniguns"  && (
           <video autoPlay playsInline  muted   ref={videoRef} src={GunsExp}  style={{
    opacity: 0.35, // Adjust the opacity value
    filter: 'brightness(2)',   position: 'absolute',
           top: 0,
           left: 0,
           width:'fit-content',
           height:"auto",
           pointerEvents: 'none', // Ensure the GIF doesn't interfere with interactions
         // Specify the animation name and duration
          }}   onPlay={handleVideoStart} onEnded={handleVideoEnded}  />
          )}
 
          
{props.healthLost > 0 && props.EnemyAttackType === "Ray Of Death"  && (
           <video autoPlay playsInline  muted   ref={videoRef} src={LaserExp2}  style={{
    opacity: 0.35, // Adjust the opacity value
    filter: 'brightness(2)',   position: 'absolute',
           top: 0,
           left: 0,
           width:'fit-content',
           height:"auto",
           pointerEvents: 'none', // Ensure the GIF doesn't interfere with interactions
         // Specify the animation name and duration
          }}   onPlay={handleVideoStart} onEnded={handleVideoEnded} />
          )}

{props.healthLost > 0 && props.EnemyAttackType === "Melee"  && (
           <video autoPlay playsInline  muted   ref={videoRef} src={MeleeExp}  style={{
    opacity: 0.35, // Adjust the opacity value
    filter: 'brightness(2)',   position: 'absolute',
           top: 0,
           left: 0,
           width:'fit-content',
           height:"auto",
           pointerEvents: 'none', // Ensure the GIF doesn't interfere with interactions
         // Specify the animation name and duration
          }}  onPlay={handleVideoStart}  />
          )}
           {props.attack === 'Repair Module' && (
            <>
        <div   className="BlastNumbers2 animate">
        <video autoPlay playsInline  muted   ref={videoRef} src={HealthExp}  style={{
    opacity: 0.35, // Adjust the opacity value
    filter: 'brightness(2)',   position: 'absolute',
        top: 0,
        left: 0,
        width:'fit-content',
        height:"auto",
        pointerEvents: 'none', // Ensure the GIF doesn't interfere with interactions
      // Specify the animation name and duration
       }}   onPlay={handleVideoStart} onEnded={handleVideoEnded}/> <p id='healthtext2' 
      
   >
     +50
   </p></div></>




      
 
      )}
       {lost && !win && (
        
        <img
          src={GAMEOVER} // Replace with the actual path to your GIF
          alt="gif-overlay"
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            pointerEvents: 'none', // Ensure the GIF doesn't interfere with interactions
            animation: 'fadeIn 1s ease-in-out forwards', // Specify the animation name and duration
          }}
        />
      
 
      )}

{win && (
        
        <video autoPlay playsInline  muted   ref={videoRef} src={WinnerExp}  style={{
    opacity: 0.35, // Adjust the opacity value
    filter: 'brightness(2)',   position: 'absolute',
        top: 0,
        left: 0,
        width:'fit-content',
        height:"auto",
        pointerEvents: 'none', // Ensure the GIF doesn't interfere with interactions
      // Specify the animation name and duration
       }}   />
      
 
      )}
   
    </div>
    <Hearts tokens1={props.Tokens}/>

 
  </div>
  </VStack>
);
};




const imageUrls1 = localStorage.getItem('enemyTeamsPics');
  const imageUrls = JSON.parse(imageUrls1!);
  
  function getRandomNumber() {
    return Math.floor(Math.random() * 2000); // Generates a number from 0 to 3000
  }

  function getRandomNumberL() {
    return Math.floor(Math.random() * 400); // Generates a number from 0 to 3000
  }
  
  const randomNum=getRandomNumber();
  const randomNumL=getRandomNumberL();

 

  

const EnemyCharacter = (props: { name: string; image: string; attack: AttackType; EnemyisAttacking: boolean; healthLost: number, playerAttackType: AttackType; EnemyHeldModules:number; computerHealth:number;isEnemyStunned1:boolean; isCriticalhit:boolean; }) => {
  const [EnemyImage, setEnemyImage] = useState(String);
  const [LegendsEnemyImage, setLegendsEnemyImage] = useState(String);
  let enemypic: string | null | undefined= null;
  const videoRef = useRef<HTMLVideoElement | null>(null);
  const [videoEnded, setVideoEnded] = useState(false);
  const videoElement = videoRef.current;
 
 
 
  useEffect(() => {
    setLegendsEnemyImage(imageUrls[randomNumL]);
    setEnemyImage(imageUrls[randomNum]);
  }, [])
  
   
  

  
 
 
 
  useEffect(() => {
   
   
    
    if (videoElement) {
     // console.log('this is running');
      // Pause and reset the video
      videoElement.pause();
      videoElement.currentTime = 0;
  
      // Conditionally set the video source based on props.attackType
      if (props.playerAttackType === 'Missiles') {
        videoElement.src = MissilesExp;} 

    if (props.playerAttackType === AttackType.RayOfDeath) {
      videoElement.src = LaserExp2;}
      
      if (props.playerAttackType === 'Miniguns') {
        videoElement.src = GunsExp;}

    if (props.playerAttackType === 'Melee') {
    videoElement.src = MeleeExp; }
    
    if (props.playerAttackType === AttackType.repairModule) {
      videoElement.src = HealthExp; }
   else {
        // Default source if none of the conditions match
        if (props.playerAttackType === 'Missiles') {
          videoElement.src = MissilesExp;} 
  
      if (props.playerAttackType === AttackType.RayOfDeath) {
        videoElement.src = LaserExp2;}
        
        if (props.playerAttackType === 'Miniguns') {
          videoElement.src = GunsExp;}
  
      if (props.playerAttackType === 'Melee') {
      videoElement.src = MeleeExp;
    

    
    
    }

   
      
      if (props.attack === AttackType.repairModule) {
        videoElement.src = HealthExp; }
       
      }
    
      // Start playing the video
     
    
      const playPromise = videoElement.play();
      
      playPromise.catch((error) => {
        console.error("Video play error:", error);
      
      });
   

      // Set up a timeout to unmute the video after a delay (e.g., 100ms)
      const unmuteTimeout = setTimeout(() => {
        videoElement.muted = false;
        videoElement.volume = 0.5;
      }, 100);
  
      
      return () => {
        // Clean up video playback and the timeout when the component is unmounted
        videoElement.pause();
        videoElement.currentTime = 0;
        clearTimeout(unmuteTimeout);
      };
    }

  },);

  const handleVideoEnded = () => {
 
   // setVideoEnded(true);
    
    // Set the videoEnded state to true when the video ends
   // console.log('video ended running');
  };

  const handleVideoStart = () => {
   
    setTimeout(() => {

      if (videoRef.current) {
      videoRef.current.muted = false;
      videoRef.current.volume = 0.5;
    }}, 100);};
    
   const health1=props.computerHealth;
    
  const getHealthColor = (health:any) => {
    if (health > 75) return 'green !important';
    if (health > 50) return 'yellow !important';
    if (health > 25) return 'orange !important';
    return 'red !important';
  };

 
    /*
  if (EnemyTeam === 'Legends') {

    enemypic = localStorage.getItem('EnemyPic')?.padStart(4, '0');
  } else {
    enemypic = String(parseInt(String(localStorage.getItem('EnemyPic')), 10));;
  }
*/



 // console.log(EnemyTeam, enemyIpfs);
 
 //console.log(props.healthLost, "healthlost", props.playerAttackType, "player attacktype", String(videoEnded),':video ended');
  return (
    <div className={`character ${props.EnemyisAttacking ? 'attacking' : ''}`}>
      <h3>{EnemyTeam}</h3>

      {LegendsEnemyImage !== null && (
        <div style={{ position: 'relative' }}>
        <Box  boxShadow={ `0px 0px 5px 3px ${getHealthColor(props.computerHealth)}`} overflow={'visible'}  position="absolute"  left={'1'} bottom='1' width="10vmin" height="10vmin" borderRadius="full" bgImage={`url(${Healthbar})`} backgroundSize="cover">
  <Text 
  fontFamily={'DSEG7'} 
  fontSize="1vw" 
  color={getHealthColor(props.computerHealth)} 
  textShadow={`5px 5px 5px ${getHealthColor(props.computerHealth)}`}
  position="absolute" 
  top="50%" 
  left="50%" 
  transform="translate(-50%, -50%)"
>
  {props.computerHealth.toFixed(0)}
</Text>
</Box>
<Box height={'fit-content'}>
        <img
        
  className={props.healthLost > 0 ? 'health-lost' : 'somename'}
  width={EnemyTeam==='D.G.P. Unlimited' ? "69%" :"100%"}
  height={EnemyTeam==='D.G.P. Unlimited' ? "69%" :"auto"}
  

 style={{ display:'inline-block', overflow:'hidden' }}


  src= {EnemyTeam !== 'caw' ? imageUrls[randomNumL]: caw}
  //{EnemyTeam === 'Legends' || EnemyTeam === 'Wyverns'? LegendsEnemyImage : EnemyImage}
/>
</Box>

             {props.healthLost === 0 && props.playerAttackType !== 'Reloading' && (
  <div className="BlastNumbers animate">
    <p
      id='healthtext'
  
    >
      MISS
    </p>
  </div>
)}

{props.isEnemyStunned1 && (
          <Box   className="stun-effect" overflow={'visible'}  position="absolute"  left={'1'} top='1' width="10vmin" height="10vmin" borderRadius="full" bgImage={`url(${Stun})`} backgroundSize="cover">
</Box>
)}


{props.isCriticalhit && (
          <Box className='criticalhit'  overflow={'visible'}  position="absolute"  left={'5vw'} bottom={'5vh'} width="20vmin" height="20vmin" borderRadius="full" bgImage={`url(${Criticalhit})`} backgroundSize="cover">
          <div id='healthtext'  className="BlastNumbers animate">
             <p  className="BlastNumbers animate" >
               -{props.healthLost.toFixed(0)}
             </p></div>
</Box>

)}
          {props.healthLost > 0 && props.playerAttackType === "Missiles"  && (
            <>
      <div id='healthtext' className="BlastNumbers animate">
        <p className="BlastNumbers animate">
          -{props.healthLost.toFixed(0)}
        </p>
      </div>
   
          <div>
          <video autoPlay playsInline  muted ref={videoRef} src={MissilesExp} style={{
    opacity: 0.35, // Adjust the opacity value
    filter: 'brightness(2)',   position: 'absolute',
           top: 0,
           left: 0,
           width:'fit-content',
           height:"auto",
           pointerEvents: 'none', // Ensure the GIF doesn't interfere with interactions
         // Specify the animation name and duration
          }}   onPlay={handleVideoStart} onEnded={handleVideoEnded}/></div></>
          )} 


{props.healthLost > 0 && props.playerAttackType === AttackType.RayOfDeath  && (
  <>
            <div id='healthtext'  className="BlastNumbers animate">
            <p  className="BlastNumbers animate" >
              -{props.healthLost.toFixed(0)}
            </p></div>
          <div>
           <video autoPlay playsInline  muted   ref={videoRef} src={LaserExp2}  style={{
    opacity: 0.35, // Adjust the opacity value
    filter: 'brightness(2)',   position: 'absolute',
           top: 0,
           left: 0,
           width:'fit-content',
           height:"auto",
           pointerEvents: 'none', // Ensure the GIF doesn't interfere with interactions
         // Specify the animation name and duration
          }}   onPlay={handleVideoStart} onEnded={handleVideoEnded} /></div></>
          )}
{props.healthLost > 0 && props.playerAttackType === "Miniguns"  && (
             <>
             <div id='healthtext'  className="BlastNumbers animate">
             <p  className="BlastNumbers animate" >
               -{props.healthLost.toFixed(0)}
             </p></div>
           <div>
           <video autoPlay playsInline  muted ref={videoRef}  src={GunsExp}  style={{
    opacity: 0.35, // Adjust the opacity value
    filter: 'brightness(2)',   position: 'absolute',
           top: 0,
           left: 0,
           width:'fit-content',
           height:"auto",
           pointerEvents: 'none', // Ensure the GIF doesn't interfere with interactions
         // Specify the animation name and duration
          }}    onPlay={handleVideoStart} onEnded={handleVideoEnded}  /></div></>
          )}

{props.healthLost > 0 && props.playerAttackType === "Melee"  && (
             <>
             <div id='healthtext'  className="BlastNumbers animate">
             <p  className="BlastNumbers animate" >
               -{props.healthLost.toFixed(0)}
             </p></div>
           <div>
           <video  autoPlay playsInline  muted  ref={videoRef} src={MeleeExp}  style={{
    opacity: 0.35, // Adjust the opacity value
    filter: 'brightness(2)',   position: 'absolute',
           top: 0,
           left: 0,
           width:'fit-content',
           height:"auto",
           pointerEvents: 'none', // Ensure the GIF doesn't interfere with interactions
         // Specify the animation name and duration
          }}   onPlay={handleVideoStart} onEnded={handleVideoEnded}  /></div></>
          )}
           
           {props.attack === 'Repair Module' && props.EnemyHeldModules>0 && (
<>
         <div className="BlastNumbers2 animate">
        <video autoPlay playsInline  muted  ref={videoRef}  src={HealthExp}  style={{
    opacity: 0.35, // Adjust the opacity value
    filter: 'brightness(2)',   position: 'absolute',
        top: 0,
        left: 20,
        width:'fit-content',
        height:"auto",
        pointerEvents: 'none', // Ensure the GIF doesn't interfere with interactions
      // Specify the animation name and duration
       }}  onPlay={handleVideoStart} onEnded={handleVideoEnded}  /><p id='healthtext2'
      
   >
     +50
   </p></div></>

      
 
      )}
           {win && (
        
        <img
          src={GAMEOVER} // Replace with the actual path to your GIF
          alt="gif-overlay"
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            pointerEvents: 'none', // Ensure the GIF doesn't interfere with interactions
            animation: 'fadeIn 1s ease-in-out forwards', // Specify the animation name and duration
          }}
        />
      
 
      )}

{!win && lost &&(
        
        <video autoPlay playsInline  muted  ref={videoRef}  src={WinnerExp}  style={{
    opacity: 0.35, // Adjust the opacity value
    filter: 'brightness(2)',   position: 'absolute',
        top: 0,
        left: 0,
        width:'fit-content',
        height:"auto",
        pointerEvents: 'none', // Ensure the GIF doesn't interfere with interactions
      // Specify the animation name and duration
       }}   />
      
 
      )}
      
        </div>
      )}
  <Text textAlign={'center'}>💀</Text>
    </div>
  );
};

const storedLegendData:any = localStorage.getItem('LegendsData') ?? '[]';
const data=JSON.parse(storedLegendData);
const NumberOfLegends = data.result ? data.result.length : 0;




const [lost, setLost]=useState(false);
const [win, setWin]=useState(false);
const [Remcomphealth, setRemcomphealth]=useState(0)
const [gameOver, setGameOver] = useState(true);
//console.log(win);
//console.log(lost);
 const Game = () => {

 
  const [playerAttackScale, setPlayerAttackScale] = useState<(score: number) => number>(() => (Score: number) => 15 + Score * 0.4);

  const [enemyAttackScale, setEnemyAttackScale ]=  useState<(Score: number) => number>(() => (Score: number)=> 
  (Score === 5 || Score === 10 ||Score === 15 || Score === 20 || Score === 25 || Score === 30 || Score === 35 || Score === 40 || Score === 45  ?  10 + Score * 0.8* 1.5 :  Score === 50 ? 10 + Score * 0.8*2 : 10 + Score * 0.8 )) ; // Adjusted from your table

 const previousScore=localStorage.getItem('previousScore');
 const [Skill, setSkill]=useState(0);
 const [Lasers, setLasers]=useState(0);
 const [AttackRating,setAttackRating]=useState(0)
 const [HealthMultiply, setHealthMultiply]=useState(0);

 const [LasersStorage, setLasersStorage]=useState(0);
 const [SkillsStorage, setSkillsStorage]=useState(0);
 const [AttackStorage, setAttackStorage]=useState(0);
 const [HealthStorage, setHealthStorage]=useState(0);
 const [HealthLevelStorage, setHealthLevelStorage]=useState(0);
 const [MeltdownsStorage, setMeltdownsStorage]=useState(0);
 const [RepairModulesStorage,  setRepairModulesStorage]=useState(0);


 
 useEffect(() => {
   const GettingCharacterData = async () => {
     if (account_name) {
       // Query the previous Tokens of the user
       const query = await new Moralis.Query(DemoRampageOneManArmy_R3);
       await query.equalTo('player', account_name);
 
       try {
         const previousCharacterObject = await query.first();
 
         if (previousCharacterObject) {
           // Compare the new Tokens with the previous Tokens
           const skillAddon = await previousCharacterObject.get('skillLevel') ;
           const attackAddon = await previousCharacterObject.get('attackLevel');
           const lasersAddon = await previousCharacterObject.get('lasersLevel');
           const HealthAddon = await previousCharacterObject.get('legendsAmount');
           const HealthLevelAddon = await previousCharacterObject.get('healthLevel');
           const MeltdownsAddon = await previousCharacterObject.get('Meltdowns');
           const RepairModulesAddon = await previousCharacterObject.get('repairmodules');

          // //console.log('skill: ', skillAddon, 'attack: ', attackAddon, 'added lasers : ', lasersAddon);
           setLasersStorage(lasersAddon);
           setSkillsStorage(skillAddon);
           setAttackStorage(attackAddon);
           setHealthStorage(HealthAddon);
           setHealthLevelStorage(HealthLevelAddon);
           setMeltdownsStorage(MeltdownsAddon);
           setRepairModulesStorage(RepairModulesAddon);
      
         } else {
           console.log('requirements not met for skills, lasers, and attack addons:');
         }
       } catch (error) {
         console.error('Error querying or saving score:', error);
       }
     }
   };
 
   GettingCharacterData();
 
 }, [Score]);



 
 useEffect(() => {
  setSkill(SkillsStorage);
  setLasers(LasersStorage);
  setAttackRating(AttackStorage);

  const playerHealthScale = (Score: number) => 80 + Score * 2.2; // Adjusted from your table
  const enemyHealthScale = (Score: number) => 100 + Score * 2.6; // Adjusted from your table
  const playerAttackScale = (Score: number) => 20 + Score * 0.76; // Adjusted from your table
  const enemyAttackScale = (Score: number) => 18 + Score * 0.8; // Adjusted from your table
  
  // Set initial health
  setPlayerHealth(playerHealthScale(Score) * (HealthLevelStorage || 1));

  
}, [SkillsStorage])



  
  
  useEffect(() => {
    localStorage.setItem("Tokens", String(Tokens))
 }, [Tokens]);


  const storedLegendData:any = localStorage.getItem('LegendsData') ?? '[]';
  const data=JSON.parse(storedLegendData);

  const TokenData2:any = localStorage.getItem('TokenData');
  const ParsedTokenData=JSON.parse(TokenData2);
 
const [StatsScore,setStatsScore]=useState(Score*1.5);
  const [playerAttack, setPlayerAttack] = useState<AttackType>(AttackType.Reloading);
const [computerAttack, setComputerAttack] = useState<AttackType>(AttackType.Reloading);
const TokensOrg=Tokens;
const [playerHealth, setPlayerHealth] = useState(0);
const [playerAttackStats, setPlayerAttackStats] = useState(0);

const [PlayerisAttacking, setPlayerIsAttacking] = useState(false);
const [EnemyisAttacking, setEnemyIsAttacking] = useState(false);

const [gameOverMessage, setgameOverMessage] = useState("");
const [playerHealthLost, setPlayerHealthLost] = useState(0);
const [computerHealthLost, setComputerHealthLost] = useState(0);
const [HeldModules, setHeldModules] = useState(0);


const [EnemySkill, setEnemySkill] = useState(0.4 + ((StatsScore || 1) * 0.01));
const [EnemyHeldModules, setEnemyHeldModules] = useState(((StatsScore || 1) / 5) < 1 ? 1 : ((StatsScore || 1) / 5));

const [computerHealth, setComputerHealth] = useState(0);
const [isEnemyStunned1, setIsEnemyStunned1] =useState(Boolean);
const [isCriticalhit, setIsCriticalhit] =useState(Boolean);
const [isPlayerCriticalhit, setIsPlayerCriticalhit] =useState(Boolean);


useEffect(() => {
if (!win && Remcomphealth>0){
setComputerHealth(Remcomphealth);} 

}, [lost]);


useEffect(() => {
  const enemyHealthScale = (Score: number) => 100 + Score * 2.6; // Adjusted from your table

  if (win){
    setComputerHealth(enemyHealthScale(Score));  }

  }, [win]);
  
useEffect(() => {
  if (Remcomphealth===0){
    const enemyHealthScale = (Score: number) => 100 + Score * 2.6; // Adjusted from your table

    setComputerHealth(enemyHealthScale(Score));  }

  }, [win]);
/*
useEffect(() => {
  setStatsScore(EnemyScore);
  setComputerHealth(100 + ((90 + (ChosenEnemyHealth * 10))));
  setEnemyHeldModules(3);
  setEnemySkill(0.5 + ((EnemyScore || 1) * 0.015));
}, [ChosenEnemyHealth, EnemyScore]);
*/
  useEffect(() => {
   // if (battleFlag && battleFlag.startsWith("Battle")) {
      setHeldModules(RepairModulesStorage);
    //}
   
    /*
    else 
      setHeldModules(1);
  */
  }, [RepairModulesStorage]);


  
  useEffect(() => {
    if ((headGear && headGear.includes("Skull"))||headGear.includes('Laser') ){
      setLasers(LasersStorage+1);
    }
  }, [headGear]);

   
  


 /*
  
 useEffect(() => {
    if (armour && armour.includes("Camo")) {
      setSkill(Skill+0.1);
    }
    else {
      setSkill(Skill);
    } 
  }, [armour]);
  console.log(paddedLegendFromStorage);*/
  /*
  useEffect(() => {
    if (paddedLegendFromStorage === "0000") {setPlayerHealth(1)
    }
  else {
    setPlayerHealth(((80 + (TokenData*2 * 10))*(HealthLevelStorage>0 ? HealthLevelStorage : 1)));
  }
  }, [gameOver]);*/

 // const [minPlayerAttack, setMinPlayerAttack] = useState(0);
//const [maxPlayerAttack, setMaxPlayerAttack] = useState(0);  
//const [minComputerAttack, setMinComputerAttack] = useState(0);
//const [maxComputerAttack, setMaxComputerAttack] = useState(0);
const [exp, setExp] = useState(0);

//console.log('beforeattacl--playerhealth:',playerHealth, 'Tokens', Tokens);
  const attack = (attackType: AttackType) => {
  

 


    setPlayerIsAttacking(true);
    setTimeout(() => {
      setEnemyIsAttacking(true);
    }, 1500);
   
    
    setTimeout(() => {

      setPlayerAttack(attackType);
     
      setTimeout(() => {
     
    
      setComputerAttack((isEnemyStunned1===true ? AttackType.Reloading : computerHealth<60 && EnemyHeldModules>=1) ?  AttackType.repairModule :
         
        Object.values(AttackType)[
          Math.floor(Math.random() * Object.values(AttackType).length)
        ]
      );
    }, 1500);
      let playerLost = 0;
      let computerLost = 0;
      
     

      const playerHealthScale = (Score: number) => 80 + Score * 2.2; // Adjusted from your table
      const enemyHealthScale = (Score: number) => 100 + Score * 2.6; // Adjusted from your table
      const playerAttackScale = (Score: number) => 15 + Score * 0.4 ; // Adjusted from your table
      const enemyAttackScale = (Score: number) => 
      (Score === 5 || Score === 10 ||Score === 15 || Score === 20 || Score === 25 || Score === 30 || Score === 35 || Score === 40 || Score === 45  ?  10 + Score * 0.8* 1.5 :  Score === 50 ? 10 + Score * 0.8*2 : 10 + Score * 0.8 ) ; // Adjusted from your table
      
   console.log('enemy attack scale: ' , (Score === 5 || Score === 10 ||Score === 15 || Score === 20 || Score === 25 || Score === 30 || Score === 35 || Score === 40 || Score === 45  ?  10 + Score * 0.8* 1.5 :  Score === 50 ? 10 + Score * 0.8*2 : 10 + Score * 0.8 )) ; // Adjusted from your table
   ;

      // Player Attacks min max values
/*
if (attackType === AttackType.Missiles) {
  setMinPlayerAttack ((0.1 + Math.random() * 0.4) * 30 + (1 * Score)+(1*(exp1/100)));
  setMaxPlayerAttack ((0.5 + Math.random() * 0.4) * 30 + (1 * Score)+(1*(exp1/100)));
} else if (attackType === AttackType.Miniguns) {
  setMinPlayerAttack((0.1 + Math.random() * 0.4) * 50 + (1 * Score)+(1*(exp1/100)));
  setMaxPlayerAttack((0.5 + Math.random() * 0.4) * 50 + (1 * Score)+(1*(exp1/100)));
} else if (attackType === AttackType.RayOfDeath && Lasers > 0) {
  setMinPlayerAttack(computerHealthPercent * 0.35);
  setMaxPlayerAttack(computerHealthPercent * 0.35);
} else if (attackType === AttackType.Melee && computerAttack !== AttackType.Melee) {
  setMinPlayerAttack((0.1 + Math.random() * 0.4) * 10 + (1 * Score)+(1*(exp1/100)));
  setMaxPlayerAttack((0.5 + Math.random() * 0.4) * 10 + (1 * Score)+(1*(exp1/100)));
}

// Computer Attacks min max values

if (computerAttack !== AttackType.repairModule && computerAttack !== AttackType.Melee && computerAttack !== playerAttack) {
  setMinComputerAttack((0.1 + Math.random() * 0.4) * 50 + (1.3 * StatsScore));
  setMaxComputerAttack((0.5 + Math.random() * 0.4) * 50 + (1.3 * StatsScore));
} else if (computerAttack === AttackType.Melee && playerAttack !== AttackType.Melee) {
  setMinComputerAttack((0.1 + Math.random() * 0.4) * 10 + (1.3 * StatsScore));
  setMaxComputerAttack((0.5 + Math.random() * 0.4) * 10 + (1.3 * StatsScore));
}
*/
// Output the results

// PLAYER ATTACKS


if (attackType === AttackType.repairModule && HeldModules > 0) {
  RepairModules();
  setHeldModules(-1);

}

if (computerAttack===AttackType.repairModule && EnemyHeldModules>0){                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     
  EnemyRepairModules();
  
 
}


if (attackType === AttackType.Missiles) {
  if (Math.random() < (Skill + 0.15)) {
    computerLost = playerAttackScale(Score*1.1) * (1+AttackRating || 1);

    setExp(exp+(computerLost/3));
    setComputerHealth(computerHealth - computerLost);
    if (Math.random()>0.9){
    setIsEnemyStunned1(true);
    console.log('enemy stunned ',isEnemyStunned1 )
  setTimeout(() => {
    setIsEnemyStunned1(false);
    console.log('enemy awake ',isEnemyStunned1 )
  }, 10000);
  } 
}}
//Starting hit probability of 70%
if (attackType === AttackType.Miniguns) {
  if (Math.random() < (Skill + 0.1)) {

    if (Math.random()>0.8){
      setIsCriticalhit(true);
      computerLost = playerAttackScale((Score*1.2) * (1+AttackRating || 1))*1.5;
   // console.log(computerLost);
    setExp(exp+(computerLost/3));
    setComputerHealth(computerHealth - computerLost);
     
      setTimeout(() => {
        setIsCriticalhit(false);
      }, 3000);
    }

   else{ computerLost = playerAttackScale(Score*1.2) * (1+AttackRating || 1);
   // console.log(computerLost);
    setExp(exp+(computerLost/3));
    setComputerHealth(computerHealth - computerLost);}
    //10% chance
   
}}

if (attackType === AttackType.Melee) {
  if (Math.random() < (Skill + 0.2)) {
    computerLost = playerAttackScale(Score*1.0) * ((1+AttackRating) || 1);
    setExp(exp+(computerLost/3));
    setComputerHealth(computerHealth - computerLost);
} }

//delivers up to 40% damage of the remaining computer health. 
if (attackType === AttackType.RayOfDeath && Lasers > 0) {
  computerLost = computerHealth * (0.20+(0.001*Score)) < 0.4 ? (0.20+0.001*Score): 0.4 ;
  setExp(exp+(computerLost/3));
  setComputerHealth(computerHealth - computerLost);
  setLasers(Lasers-1);
} 

// ENEMY ATTACKS
// ENEMY REPAIR MODULES
/*
if (computerAttack === AttackType.repairModule && EnemyHeldModules > 0) {
  setComputerHealth(computerHealth + 20 + StatsScore);
  setEnemyHeldModules(EnemyHeldModules-1);

}*/

// OTHER ENEMY ATTACKS
setTimeout(() => {
  

if ((computerAttack !== AttackType.repairModule && computerAttack !== AttackType.Melee && computerAttack !== AttackType.Reloading) && !isEnemyStunned1) {
  if (Math.random() < EnemySkill) {
    
    if (Math.random()>0.9){
      setIsPlayerCriticalhit(true);

    playerLost = enemyAttackScale((Score*1.2)*2);   
     setPlayerHealth(playerHealth - playerLost);
   
     
     setTimeout(() => {
      setIsPlayerCriticalhit(false);
    }, 3000);

  } else if (!isEnemyStunned1){
    playerLost = enemyAttackScale((Score*1.2));   
    setPlayerHealth(playerHealth - playerLost);
  

  }
  
}}


// ENEMY MELEE ATTACKS
if (computerAttack === AttackType.Melee || ((computerAttack === AttackType.Reloading && playerAttack!== AttackType.Reloading ) && !isEnemyStunned1)) {
  console.log('CA',computerAttack, 'PA',playerAttack);
  if (Math.random() < (EnemySkill + 0.3)) {
    playerLost = enemyAttackScale(Score*1);   
    setPlayerHealth(playerHealth - playerLost);
  
  }}

  if (computerAttack === AttackType.repairModule && !isEnemyStunned1 ) {
    if (EnemyHeldModules>=1){
const newEnemyHealth = computerHealth + 50;
setComputerHealth(newEnemyHealth);
setEnemyHeldModules(EnemyHeldModules - 1);}

else if ((Math.random() < (EnemySkill + 0.3)))

{ playerLost = enemyAttackScale(Score*1);   
  setPlayerHealth(playerHealth - playerLost);}
    } 
  
  }, 1500);
   //FIX
  

  
setComputerHealthLost(computerLost);
setTimeout(() => {
  

setPlayerHealthLost(playerLost);
}, 1500);
setTimeout(() => {
  setPlayerIsAttacking(false);
  setEnemyIsAttacking(false);
}, 2500);


//console.log('before--playerhealth:',playerHealth, 'playerLost', playerLost);
setTimeout(() => {
  

 if ((playerHealth-playerLost)<0){
 // console.log('should end here');

    setDisabled(true);

    setScore(Score);
   
//console.log('player health below')
//console.log('inside--playerhealth:',playerHealth, 'playerLost', playerLost);
    
  const SettingData = async () => {
    // Query the previous score of the user
    const query = new Moralis.Query(DemoRampageOneManArmy_R3);
     await query.equalTo('player', account_name);
    
      const previousScoreObject = await query.first();
      if(previousScoreObject){
      previousScoreObject.set('tokens',(Tokens-1));
      await previousScoreObject.save();
//console.log('database tokens updated:',(Tokens-1));
}
  }
 SettingData();
  
 
 

 
 

   
   setTokens(Tokens-1);
  
   setRemcomphealth(computerHealth);

  setLost(true);

 
      
   

    setGameOver(true);
 

  setBattleOutcome(
    <VStack>
     
    <Tag 
    fontSize={'3vw'}
    color={'red'}
    animation= 'result-animation 4s ease-in-out'
    background='whiteAlpha.600'
    backdropBlur={'5px'}
  position= 'absolute'
  top={'50vmax'}
  zIndex='100000'

 


    opacity='0' 
  
      textAlign={'center'}
      justifyContent={'center'}
      flexDirection={'column'}
      padding={'1vw'}
     
      >
          You lose,<br></br>
           rest in pieces,
           <br></br> legend!
        </Tag>

          
             </VStack>
  );






  if (Tokens <= 1) {
   
   
   /*
      localStorage.setItem("Tokens", String(Tokens-1));
      localStorage.setItem('Timer',"initialized");


      const SettingTimer = async () => {
        // Query the previous score of the user
        const query = new Moralis.Query(RampageOneManArmy_R3);
         await query.equalTo('player', address);
         const previousScoreObject = await query.first();
        if(previousScoreObject){
       
          previousScoreObject.set('reset',true);
    //console.log('TokensReset initialized');
    await previousScoreObject.save();
      }}
     SettingTimer();
     */ 
     

   //WRITE IN HERE THE CODE THAT SAVES TOKENS 0 TO MONGODB. ALSO WRITE IN THE RETURN STATEMENT (TOKENS LESS THAN ZERO) THAT THE CODE CHECKS UPDATE TIME OF TOKENS 0.IF THE TIME IS LESS THAN 6 HRS, SHOW TIMER, IF NOT REVERT BACK TO NUMBER OF LEGENDS.
   //IF THE CODE DOESN'T WORK, ADD SETTOKENS(NUMBEROFLEGENDS). 
 
/*
    if(Score<10){
    setScore(1);}
   else if (Score >= 10 && Score < 20) {
    setScore(10);
  } else if (Score >= 20 && Score < 30) {
    setScore(20);
    // You can continue adding more milestones and conditions here.
  } else if (Score >= 30 && Score < 40) {
    setScore(30);
  } else if (Score >= 40 && Score < 50) {
    setScore(40);
  } else if (Score >= 50 && Score < 60) {
    setScore(50);
  } else if (Score >= 60 && Score < 70) {
    setScore(60);
  } else if (Score >= 70 && Score < 80) {
    setScore(70);
  } else if (Score >= 80 && Score < 90) {
    setScore(80);
  } else if (Score >= 90 && Score < 100) {
    setScore(90);
  } else if (Score >= 100 && Score < 150) {
    setScore(100);
  } else if (Score >= 150 && Score < 200) {
    setScore(150);
  } else if (Score >= 200) {
    setScore(200);
  }*/
    setLost(false);

     
 
   

    return (
     
      setBattleOutcome(
        <>
        
       <Tag 
       fontSize={'3vw'}
       color={'red'}
       animation= 'result-animation 4s ease-in-out'
       background='whiteAlpha.600'
       backdropBlur={'5px'}
     position= 'absolute'
     top={'50vmax'}
  zIndex='100000'
       opacity='0' 
     
         textAlign={'center'}
         justifyContent={'center'}
         flexDirection={'column'}
         padding={'1vw'}
        
         >
          
              YOU RUN OUT OF TOKENS! regroup and come back stronger
            </Tag>
            </>
    ));
  }
  


}

else if ((computerHealth-computerLost)<0 ) {
  setDisabled(true);
  setLost(false);
  setWin(true);
  setTeamScore(TeamScore+1);
  setRemcomphealth(0);

  setExp1(exp1 + (exp===0 ? (computerHealth/2) : ((exp/2)>=10 ? (exp/2) : 10)));
  console.log(exp1 + (exp===0 ? (computerHealth/2) : ((exp/2)>=10 ? (exp/2) : 10)));
    //setExp(0);
    
    setScore(Score < 50 ? Score + 1 : Score);
   

    
  const SettingNFTwin = async () => {
    // Query the previous score of the user
    const currentTime = new Date();
    const query = new Moralis.Query(DemoRampageOneManArmy_R3);
     await query.equalTo('player', account_name);
    
      const previousScoreObject = await query.first();
      if(previousScoreObject){
      previousScoreObject.set('NFTwinner',currentTime);
      await previousScoreObject.save();
      }
      return(
console.log(''));
  }
   
   
   
 
   
    
  setGameOver(true);


  setTimeout(() => {
    setIsModalOpen2(true);
   }, 2500);
 

setTimeout(() => {
 setIsModalOpen2(false)
}, 10000);



  setBattleOutcome(
    
   <Tag 
        fontSize={'3vw'}

        animation='result-animation forwards 4s ease-in-out'
        background='whiteAlpha.600'
        backdropBlur={'5px'}
        position='absolute'
        top={'50vmax'}
        zIndex='100000'
        opacity='0'

        textAlign={'center'}
        justifyContent={'center'}
        flexDirection={'column'}
        padding={'1vw'}

      >

        <Tag fontSize={'1.5vw'} backgroundColor={'transparent'} color={'green.700'}>
          You are victorious Legend!

        </Tag>
        <Tag color={'green.700'} fontSize={'1.5vw'} padding={'1vw'} backgroundColor={'transparent'}>
          <Avatar
            src={ExpPic}
            size='md'
            name='exp'
            ml='5'
            mr='auto' />
          <TagLabel>{(exp === 0 ? (computerHealth / 2) : ((exp / 2) >= 10 ? (exp / 2) : 10)).toFixed(0)} gained</TagLabel></Tag>

        {/*change to state variable*/}
        {Math.random() > 0.999999999999999999999999999999999999 && (
          <Tag fontSize={'1.5vw'} backgroundColor={'transparent'}>
            <Avatar
              src={RR}
              size='md'
              name='RR'
              ml='5'
              mr='auto' />
            <TagLabel>Legends NFT gained</TagLabel></Tag>
        )}
      </Tag>

  
  );
}

}, 2500);
    }, 500);};
  
  
  
  
//    if (gameOver===true){
  //    useEffect(() => {
    //    setIsModalOpen(true);
      
      //}, [])
      
    //}
/*
    useEffect(() => {
      localStorage.setItem(String(Team),String(TeamScore));
    
      return () => {
          <Alert>team score updated {TeamScore}</Alert>
      }
    }, [TeamScore])

    useEffect(() => {
      localStorage.setItem(String(Team),String(TeamScore));
    
      return () => {
          <Alert>team score updated {TeamScore}</Alert>
      }
    }, [TeamScore])
    
*/
  const rematch =  ()  => {
    
    setPlayerAttack(AttackType.Reloading);
    setComputerAttack(AttackType.Reloading);
    setGameOver(false);
  
   setLost(false);
    setWin(false);
   
   

};

const RepairModules = () => {
  if (HeldModules<=0) 
  {console.log("OUT OF REPAIR MODULES")
}

else { 
const newHealth = playerHealth + 50;
setPlayerHealth(newHealth);
setHeldModules(HeldModules - 1);
setPlayerAttack(AttackType.repairModule);}}


const EnemyRepairModules = () => {
  if (EnemyHeldModules<=0) 
  {console.log("enemy OUT OF REPAIR MODULES")
}

else { 
setComputerHealth(computerHealth+50);
setEnemyHeldModules(EnemyHeldModules-1);
}}

const [isDisabled, setDisabled] = useState(false);
 
const playerHealthPercent = (playerHealth / 100) * 100;
const computerHealthPercent = (computerHealth / 100) * 100;

const squareStyle = {
  height: '1vw',
  width: '1.5vw',
  borderRadius: '0.1vw',
  margin: '0.3vw',
  padding:'0.5vw'

}



  

const [showRampageInfo, setShowRampageInfo] = useState(false);




/*
const [timeRemaining, setTimeRemaining] = useState<string | null>(null);
function Timer() {
 

  useEffect(() => {
    // Calculate the time remaining until October 14, 2023, at 18:00 GMT
    const targetDate = new Date('2023-11-14T18:00:00Z');
    const now = new Date();
    const timeDifference = targetDate.getTime() - now.getTime();

    // Check if the target date has passed
    if (timeDifference <= 0) {
      setTimeRemaining('Tournament round 2 has begun, Join the fight!!');
      return;
    }

    // Calculate days, hours, minutes, and seconds
    const days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
    const hours = Math.floor((timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);

    setTimeRemaining(
      `PREP and training phase initiated. Round 2 will begin in ${days} days, ${hours} hours and  ${minutes} minutes`
    );
  
  }, []);

  return (
    <Box textAlign={'center'} justifyContent={'center'} fontWeight={'bold'} borderWidth='0.2vw' borderRadius='5px' borderColor='green' width={'90%'} textColor={'green'} mt={6} fontSize={'1vw'}>
     
      {timeRemaining}
    </Box>
  )};*/





//console.log(Lasers, Skill);


const RobotHealthUI = () => {
  const [health, setHealth] = useState(playerHealth); // Initial health

 /* useEffect(() => {
    // Decrease health for demonstration
    const interval = setInterval(() => {
      setHealth((prevHealth) => (prevHealth > 0 ? prevHealth - 1 : 0));
    }, 1000);

    return () => clearInterval(interval);
  }, []);
*/
  const getHealthColor = (health:any) => {
    if (health > 75) return 'green';
    if (health > 50) return 'yellow';
    if (health > 25) return 'orange';
    return 'red';
  };

  return (
    <div style={{
      fontFamily: 'DSEG7',
      fontSize: '1vw',
      color: getHealthColor(health),
      textShadow: `5px 5px 5px ${getHealthColor(health)}`,
     
      textAlign: 'center', 
      zIndex:'500'

    }}>
      {health.toFixed(0)}
    </div>
  );
};

const calculatePosition = (index:any, totalItems:any) => {
  const angle = (2 * Math.PI) / totalItems * index; // angle in radians
  const radius = 15; // radius of the circle in 'vmin' units, increased to position buttons correctly
  const left = 7 + radius * Math.cos(angle); // adjust 50 to move the circle horizontally
  const top = 7 + radius * Math.sin(angle); // adjust 50 to move the circle vertically
  return { left: `${left}vmin`, top: `${top}vmin` };
};

// Component to render each button

type AttackButtonProps = {
  index: number;
  totalItems: number;
  children: ReactNode;
  disabled: boolean;
  onClick: MouseEventHandler<HTMLButtonElement>;
};

const AttackButton: React.FC<AttackButtonProps> = ({ index, totalItems, children, disabled, onClick }) => {
    const position = calculatePosition(index, totalItems);
  return (
    <button style={{ 
      position: 'relative', 
    
      width: '15vmin', 
      height: '15vmin', 
      borderRadius: '50%', 
      borderColor: 'transparent',
      ...buttonCommonStyles 
    }} disabled={disabled} onClick={onClick}>
      {children}
    </button>
  );
};

// Common styles for buttons to avoid repetition
const buttonCommonStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
};


const MissileSoundRef = useRef<HTMLAudioElement | null>(null);
const LaserSoundRef = useRef<HTMLAudioElement | null>(null);
const GunsSoundRef = useRef<HTMLAudioElement | null>(null);
const HealthSoundRef = useRef<HTMLAudioElement | null>(null);
const MeleeSoundRef = useRef<HTMLAudioElement | null>(null); // Declare the ref for the sound
// Main component
const AttackUI = () => {
  const totalItems = 5; // Corrected to match the number of buttons

  
  return (
    <Flex direction={'row'} justifyContent="center" alignItems="center" position="relative" height="fit-content" width="full"> {/* Increased size */}
      {/* Central health frame */}
     

      {/* Position buttons in a circle */}
      <AttackButton index={1} totalItems={totalItems} disabled={PlayerisAttacking} onClick={() => { attack(AttackType.RayOfDeath);  if (LaserSoundRef.current) {
        LaserSoundRef.current.currentTime = 0;
        LaserSoundRef.current.play().then(() => {
          // Playback started successfully
        })
        .catch(error => {
          console.error('Playback failed:', error);
        });;;
      }}}>
        <img style={{borderRadius:'50%'}} src={Swords} alt='RayOfDeath' />
  
      </AttackButton>
   
      <AttackButton index={2} totalItems={totalItems} disabled={PlayerisAttacking} onClick={() => { attack(AttackType.Missiles);  if (MissileSoundRef.current) {
        MissileSoundRef.current.currentTime = 0;
        MissileSoundRef.current.play().then(() => {
          // Playback started successfully
        })
        .catch(error => {
          console.error('Playback failed:', error);
        });;;
      } }}>
        <img style={{borderRadius:'50%'}} src={missiles} alt='Missiles' />
      
      </AttackButton>
  
      <AttackButton index={3} totalItems={totalItems} disabled={PlayerisAttacking } onClick={() => { attack(AttackType.Miniguns);  if (GunsSoundRef.current) {
        GunsSoundRef.current.currentTime = 0;
        GunsSoundRef.current.play().then(() => {
          // Playback started successfully
        })
        .catch(error => {
          console.error('Playback failed:', error);
        });;
      } }}>
        <img style={{borderRadius:'50%'}} src={miniguns} alt='Miniguns' />
      
      </AttackButton>
  
      <AttackButton index={4} totalItems={totalItems} disabled={PlayerisAttacking} onClick={() => { attack(AttackType.Melee);
        if (MeleeSoundRef.current) {
          MeleeSoundRef.current.currentTime = 0;
          MeleeSoundRef.current.play().then(() => {
            // Playback started successfully
          })
          .catch(error => {
            console.error('Playback failed:', error);
          });
        } }}>
        <img style={{borderRadius:'50%'}} src={Melee} alt='Melee' />
     
      </AttackButton>
   
      <AttackButton index={5} totalItems={totalItems} disabled={PlayerisAttacking || HeldModules < 1} onClick={() => { RepairModules(); }}>
        <img style={{borderRadius:'50%'}} src={Star} alt='RepairModules' />
       
      </AttackButton>
 

     
    </Flex>
    
  );
};


const handleCloseModal = () => {
  setIsModalOpen2(false);
};

return (
<Container  centerContent width={'100%'}>
  <VStack backgroundSize={'contain'} minWidth={'50vw'} id='game'     alignSelf={'center'} alignItems={'center'}
  style={{
   
  }}
  >


 
<Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
<ModalOverlay />

<ModalContent backgroundColor={'black'} textColor={'white'} className='nft-cards'>
<Box paddingBottom={'2vw'}>
<ModalCloseButton />
</Box>
<ModalHeader padding={'1vw'}>Choose your Legend</ModalHeader>

<ModalBody>
{Team === 'Ryoshi Tales VIP' ? (
  <NFTGridEB />
) : (
  <NftGridG address={address} chain="0x19" />
)}
</ModalBody>
</ModalContent>
</Modal>

<div   className="game"  style={{  backgroundImage:
  Score === 5 ? `url(${path})` :
  Score === 10 ? `url(${refinery})` :
  Score === 15 ? `url(${redforest})` :
  Score === 20 ? `url(${temple})` :
  Score === 25 ? `url(${greencoast})` :
  Score === 30 ? `url(${cave})` :
  Score === 35 ? `url(${icepalace})` :
  Score === 40 ? `url(${forest})` :
  Score === 45 ? `url(${portal})` :
  Score === 50 ? `url(${tower})` :
  Score < 25 ?`url(${circuit})`: `url(${circuitred})`, padding:'2vw', alignSelf:'center' ,width: '100%', height: 'auto', zoom: '100%' }}>
<Text  id='stage'  justifyContent={'center'} height={'1.5vw'} width={'full'}   textAlign='center' fontSize='2vh'  textShadow={'5px 5px 5px black '} textColor={'white'}  >STAGE {Score}</Text>
<VStack textAlign={'center'}  justifyItems={'center'} justifySelf={'center'} width='95%' fontSize='1vw' >
   <HStack  paddingTop={'20px'} >

     
<VStack width={'50%'} height='auto' >



<Character
  name="Player"
  image={player}
  attack={playerAttack}
  PlayerisAttacking={PlayerisAttacking}
  healthLost={playerHealthLost}
  EnemyAttackType={computerAttack}
  MeltdownsStorage={MeltdownsStorage}
  Tokens={Tokens}
  playerHealth={playerHealth}
  isPlayerCriticalhit={isPlayerCriticalhit}
/>



  
<Box  borderRadius={'20%'} className='characterStats' backgroundColor={'black'} width={'full'}>
<VStack  align="center" >
 
    <Text fontSize="0.8vw" fontWeight="bold">
      {account_name}
    
    </Text>
  
    <HStack  justifyContent={'center'} width='100%' padding={'1vw'} >
 
  <VStack><img style={{width:'2vmax'}} height={'auto'} src={ExpPic}></img> <Text>{exp1.toFixed(0)} </Text></VStack>
  <VStack>
  <img style={{width:'2vmax'}} height={'auto'} src={SkillPic}></img> <Text>{(Skill ? (Skill.toFixed(1)):0.4)} </Text></VStack>
 
  <VStack><img style={{width:'2vmax'}} height={'auto'} src={missiles}></img> <Text>{(playerAttackScale(Score*1.1)*(1+AttackRating || 1)).toFixed(0)} </Text></VStack>
  <VStack><img style={{width:'2vmax'}} height={'auto'} src={miniguns}></img> <Text>{(playerAttackScale(Score*1.2)*(1+AttackRating || 1)).toFixed(0)} </Text></VStack>
  <VStack><img style={{width:'2vmax'}} height={'auto'} src={Melee}></img> <Text>{(playerAttackScale(Score*1)*(1+AttackRating || 1)).toFixed(0)} </Text></VStack>
  <VStack> <img style={{width:'2vmax'}} height={'auto'} src={Star}></img> <Text>{HeldModules} </Text></VStack>


    </HStack>
 

  </VStack>
</Box>

      </VStack>
      
      <VStack width={'50%'} height='auto'>
      <EnemyCharacter name="Enemy" image={enemy} attack={computerAttack} EnemyisAttacking={EnemyisAttacking} healthLost={computerHealthLost} playerAttackType={playerAttack} EnemyHeldModules={EnemyHeldModules} isEnemyStunned1={isEnemyStunned1} isCriticalhit={isCriticalhit} computerHealth={Number(computerHealth.toFixed(0))}/>
      <Box  borderRadius={'20%'} className='characterStats' backgroundColor={'black'} width={'full'}>
  <VStack align="center">
    <Text fontSize="0.8vw" fontWeight="bold">
      Enemy
    </Text>
    <HStack justifyContent={'center'} width='100%' padding={'1vw'}>
    <VStack><img style={{width:'2vmax'}} height={'auto'} src={SkillPic}></img> <Text>{EnemySkill.toFixed(1)} </Text></VStack>
 
    <VStack><img style={{width:'2vmax'}} height={'auto'} src={missiles}></img> <Text>({(enemyAttackScale(Score*1.2)).toFixed(0)} </Text></VStack>
    <VStack><img style={{width:'2vmax'}} height={'auto'} src={miniguns}></img> <Text> - </Text></VStack>
    <VStack><img style={{width:'2vmax'}} height={'auto'} src={Melee}></img> <Text>{(enemyAttackScale(Score*1)).toFixed(0)}) </Text></VStack>
    <VStack> <img style={{width:'2vmax'}} height={'auto'} src={Star}></img> <Text>{EnemyHeldModules>0 ? (EnemyHeldModules).toFixed(0) : 0} </Text></VStack>
  
  
 
    </HStack>
  </VStack>
</Box>



      </VStack>
    
 
      
    </HStack>
    <HStack justifyContent='center'>
     
     
    </HStack>
    {!gameOver && (
      <VStack>
      


     <AttackUI />
     <audio preload="none" ref={MeleeSoundRef}>
     <source src={MeleeSound} type="audio/mpeg" />
     Your browser does not support the audio element.
   </audio>
   <audio ref={LaserSoundRef}>
   <source src={LaserSound} type="audio/mpeg" />
   Your browser does not support the audio element.
 </audio>
 <audio ref={MissileSoundRef}>
 <source src={MissileSound} type="audio/mpeg" />
 Your browser does not support the audio element.
</audio>
<audio preload="none" ref={GunsSoundRef}>
<source src={GunsSound} type="audio/mpeg" />
Your browser does not support the audio element.
</audio>
<audio preload="none" ref={HealthSoundRef}>
<source src={HealthSound} type="audio/mpeg" />
Your browser does not support the audio element.
</audio>
<Button  bg='blackAlpha.700' variant="outline" textColor={'black'} color='orangered' width={'-moz-fit-content'} fontSize={'1.5vw'} onClick={() => setGameOver(true)}>Quit round</Button>
   </VStack>
    )}
    
    
    // Common styles for buttons to avoid repetition
   
    
  {gameOver && (
    <>
    

    <Box width="full">
  
    <Box fontSize='1vw' marginTop='1vw'>
  
    </Box>

    <form
        onSubmit={(event) => {
          event.preventDefault();
          setIsModalOpen(true)
         
        }}
      >
       <VStack>
  {battleOutcome}
  <MapModal
isOpen={isModalOpen2}
onClose={handleCloseModal}
OneManArmyRCRO={Score} />

  <Button padding='1' type="submit" fontSize={'1.3vw'} boxSize='full' minWidth={'-moz-fit-content'} bgColor='black' color="orangered" variant="outline">
    CHOOSE YOUR LEGEND
  </Button>
</VStack>
      </form>
    </Box>
<HStack>

{Tokens > 0 && paddedLegendFromStorage !== '0000'?  (
  <HStack>
      <Button fontSize={'1vw'} onClick={() => {
        setPlayerAttack(AttackType.Reloading);
        setComputerAttack(AttackType.Reloading);
        setGameOver(false);
      
       setLost(false);
        setWin(false);
        }} bgColor='black' isDisabled={Score>50 ? true: false} color="orangered" variant="outline">
        {Score>50 ? 'INITIATE MELTDOWN TO CONTINUE': 'TO BATTLE'}
    </Button> <Spacer padding={'0.3vw'}></Spacer>
     <Button fontSize={'1vw'} bgColor='black' color="orangered" variant="outline"><Spacer padding={'0.3vw'}></Spacer>
     <Link to='../Rampage/Demo'> Quit game</Link>
   </Button>
   <Button  fontSize={'1vmax'} bgColor='rgba(0, 0, 0, 0.6)' color="orangered" variant="outline" onClick={() => {setIsModalOpen2(true)}} > Open Map </Button>
   </HStack>
      ) : (
        <HStack>
        {Tokens === 0 &&(
        <Button fontSize={'1vw'}bgColor='black' color="orangered" variant="outline" isDisabled>
        No Tokens left
                </Button>)}

                {paddedLegendFromStorage === '0000' &&(
                  <Button fontSize={'1vw'}bgColor='black' color="orangered" variant="outline" isDisabled>
                  Choose a Legend 
                          </Button>)}


         <Button fontSize={'1vw'} bgColor='black' color="orangered" variant="outline">
         <Link to='../Rampage/Demo'> Quit game</Link>
       </Button>
       </HStack>
      )}<Spacer padding={'0.3vw'}></Spacer>
    <Button fontSize={'1vw'} bgColor='black' color="orangered" variant="outline" onClick={() => setShowRampageInfo(true)} >how to play </Button>
    {showRampageInfo && <RampageInfo />}
   </HStack>
    
 
    </>

  )}
  </VStack>
  
</div>

     <TopHighScores />
     <Timer />
</VStack>
</Container>
);
  };


return (
  <VStack >
  <Game  />
  <Audio />
  </VStack>
  
 
  )};
export default AppGCrofam;


 
 